import { ISelectOption } from '../types/form'

export const UNIT_PLAN_STATUS_OPTIONS: ISelectOption[] = [
  {
    label: 'OLD',
    value: 'OLD'
  },
  {
    label: 'CURRENT',
    value: 'CURRENT'
  }
]

export const UNIT_PLAN_PRODUCT_RANGE_OPTIONS: ISelectOption[] = [
  {
    label: 'ALL',
    value: 'ALL'
  },
  {
    label: 'TRK',
    value: 'TRK'
  }
]

export enum UnitPlanUpgradeability {
  all = 'all',
  fixed = 'fixed',
  upgrade = 'upgrade',
  downgrade = 'downgrade'
}

export const UNIT_PLAN_UPGRADEABILITY_OPTIONS: ISelectOption[] = [
  {
    label: 'All',
    value: UnitPlanUpgradeability.all
  },
  {
    label: 'Fixed',
    value: UnitPlanUpgradeability.fixed
  },
  {
    label: 'Upgrade only',
    value: UnitPlanUpgradeability.upgrade
  },
  {
    label: 'Downgrade only',
    value: UnitPlanUpgradeability.downgrade
  }
]
